module.exports = __webpack_public_path__ + "public/media/creator-header-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-header-icon.png
// module id = ./images/services/creator-header-icon.png
// module chunks = 0